import { Pipe, PipeTransform } from '@angular/core'
/* 
Some titles are really long, so let's truncate them
to a length of an input provided from the attr
*/

@Pipe({name: 'titleFormat'})
export class TitleFormatPipe implements PipeTransform {
  transform(title: string, max_characters: number): string {
    return title.length >= max_characters ? `${title.substr(0,max_characters)}...` : title;
  } 
}


// WEBPACK FOOTER //
// /Users/martyndavies/code/algolia/essentialvault-angular/src/app/helpers/titleformat.pipe.ts